// Organization
import {
  ORGANIZATION_FORM_CLEAR,
  ORGANIZATION_FORM_FETCH_REQUEST,
  ORGANIZATION_FORM_FETCH_RESPONSE_ERROR,
  ORGANIZATION_FORM_FETCH_RESPONSE_SUCCESS,
  ORGANIZATION_FORM_INIT_REQUEST,
  ORGANIZATION_FORM_INIT_RESPONSE_ERROR,
  ORGANIZATION_FORM_INIT_RESPONSE_SUCCESS,
  ORGANIZATION_FORM_SUBMIT_REQUEST,
  ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
  ORGANIZATION_FORM_SUBMIT_RESPONSE_SUCCESS,
  ORGANIZATION_GRID_CHANGE_FILTER,
  ORGANIZATION_GRID_CHANGE_PAGINATION,
  ORGANIZATION_GRID_CHANGE_SORT,
  ORGANIZATION_GRID_DELETE_REQUEST,
  ORGANIZATION_GRID_DELETE_RESPONSE_ERROR,
  ORGANIZATION_GRID_DELETE_RESPONSE_SUCCESS,
  ORGANIZATION_GRID_FETCH_REQUEST,
  ORGANIZATION_GRID_FETCH_RESPONSE_ERROR,
  ORGANIZATION_GRID_FETCH_RESPONSE_SUCCESS,
} from "../constants/actionTypes";

const initialState = {
  formData: {},
  formDataParents: [],
  formErrors: [],
  formIsFetching: false,
  formIsInitializing: false,
  formIsSubmitting: false,
  gridData: [],
  gridDataTotal: 0,
  gridIsDeleting: false,
  gridErrors: [],
  gridIsFetching: false,
  gridFilters: [],
  gridPage: 1,
  gridPageSize: 10,
  gridSortField: "nameComposed",
  gridSortOrder: "asc",
};

const organization = (state = initialState, action) => {
  switch (action.type) {
    // FORM - Clear
    case ORGANIZATION_FORM_CLEAR:
      return {
        ...state,
        formData: {},
        formDataParents: [],
        formErrors: [],
        formIsFetching: false,
        formIsInitializing: false,
        formIsSubmitting: false,
      };

    // FORM - Fetch
    case ORGANIZATION_FORM_FETCH_REQUEST:
      return {
        ...state,
        formData: {},
        formErrors: [],
        formIsFetching: true,
      };
    case ORGANIZATION_FORM_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsFetching: false,
      };
    case ORGANIZATION_FORM_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        formData: action.payload,
        formIsFetching: false,
      };

    // FORM - Init
    case ORGANIZATION_FORM_INIT_REQUEST:
      return {
        ...state,
        formIsInitializing: true,
      };
    case ORGANIZATION_FORM_INIT_RESPONSE_ERROR:
      return {
        ...state,
        formDataParents: [],
        formIsInitializing: false,
      };
    case ORGANIZATION_FORM_INIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formDataParents: action.payload.parents,
        formIsInitializing: false,
      };

    // FORM - Submit
    case ORGANIZATION_FORM_SUBMIT_REQUEST:
      return {
        ...state,
        formIsSubmitting: true,
      };
    case ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsSubmitting: false,
      };
    case ORGANIZATION_FORM_SUBMIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formErrors: [],
        formIsSubmitting: false,
      };

    // GRID - Change - Filter
    case ORGANIZATION_GRID_CHANGE_FILTER:
      return {
        ...state,
        gridFilters: action.payload.filters,
      };

    // GRID - Change - Pagination
    case ORGANIZATION_GRID_CHANGE_PAGINATION:
      return {
        ...state,
        gridPage: action.payload.page,
        gridPageSize: action.payload.pageSize,
      };

    // GRID - Change - Sort
    case ORGANIZATION_GRID_CHANGE_SORT:
      return {
        ...state,
        gridSortField: action.payload.sortField,
        gridSortOrder: action.payload.sortOrder,
      };

    // GRID - Delete
    case ORGANIZATION_GRID_DELETE_REQUEST:
      return {
        ...state,
        gridIsDeleting: true,
      };
    case ORGANIZATION_GRID_DELETE_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridIsDeleting: false,
        gridErrors: action.payload,
      };
    case ORGANIZATION_GRID_DELETE_RESPONSE_SUCCESS:
      return {
        ...state,
        gridIsDeleting: false,
        gridErrors: [],
      };

    // GRID - Fetch
    case ORGANIZATION_GRID_FETCH_REQUEST:
      return {
        ...state,
        gridIsFetching: true,
      };
    case ORGANIZATION_GRID_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridErrors: action.payload,
        gridIsFetching: false,
      };
    case ORGANIZATION_GRID_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        gridData: action.payload.data,
        gridDataTotal: action.payload.total,
        gridErrors: [],
        gridIsFetching: false,
      };
    default:
      return state;
  }
};

export default organization;
